/**
 * @flow
 * @relayHash 296931e268f37b042a63dcaec0fef4ad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentsRequiringAcceptancePageQueryVariables = {|
  first?: ?number,
  after?: ?string,
  sort?: ?string,
  categories?: ?$ReadOnlyArray<?number>,
|};
export type DocumentsRequiringAcceptancePageQueryResponse = {|
  +documentsToAccept: ?{|
    +categories: ?$ReadOnlyArray<?{|
      +pk: ?number,
      +name: string,
    |}>,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +documentsToAccept: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +document: ?{|
            +pk: ?number,
            +name: string,
            +bloc: {|
              +name: string
            |},
            +category: {|
              +name: string
            |},
            +author: {|
              +firstName: string,
              +lastName: string,
              +profile: ?{|
                +title: ?string
              |},
            |},
            +expirationDate: ?string,
          |},
          +documentImport: ?{|
            +pk: ?number,
            +importFile: ?{|
              +name: ?string,
              +url: ?string,
              +zipName: ?string,
              +zipUrl: ?string,
            |},
          |},
        |}
      |}>,
    |},
  |}
|};
export type DocumentsRequiringAcceptancePageQuery = {|
  variables: DocumentsRequiringAcceptancePageQueryVariables,
  response: DocumentsRequiringAcceptancePageQueryResponse,
|};
*/


/*
query DocumentsRequiringAcceptancePageQuery(
  $first: Int
  $after: String
  $sort: String
  $categories: [Int]
) {
  documentsToAccept(sort: $sort, categories: $categories) {
    categories {
      pk
      name
      id
    }
    error {
      statusCode
      message
    }
    documentsToAccept(first: $first, after: $after) {
      totalCount
      edges {
        node {
          document {
            pk
            name
            bloc {
              name
              id
            }
            category {
              name
              id
            }
            author {
              firstName
              lastName
              profile {
                title
                id
              }
              id
            }
            expirationDate
            id
          }
          documentImport {
            pk
            importFile {
              name
              url
              zipName
              zipUrl
            }
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "categories",
    "type": "[Int]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "categories",
    "variableName": "categories",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v7 = [
  v3
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "importFile",
  "storageKey": null,
  "args": null,
  "concreteType": "ImportFileType",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zipName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zipUrl",
      "args": null,
      "storageKey": null
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = [
  v3,
  v13
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DocumentsRequiringAcceptancePageQuery",
  "id": "356a226ccbca001d569d07ad2004073a",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DocumentsRequiringAcceptancePageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToAccept",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentsToAcceptPageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryType",
            "plural": true,
            "selections": [
              v2,
              v3
            ]
          },
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentsToAccept",
            "storageKey": null,
            "args": v5,
            "concreteType": "DocumentImportAcceptCountableConnection",
            "plural": false,
            "selections": [
              v6,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentImportAcceptCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentImportAcceptType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "bloc",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BlocType",
                            "plural": false,
                            "selections": v7
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": v7
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "author",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ApprovalStepUserType",
                            "plural": false,
                            "selections": [
                              v8,
                              v9,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProfileType",
                                "plural": false,
                                "selections": [
                                  v10
                                ]
                              }
                            ]
                          },
                          v11
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentImport",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentImportType",
                        "plural": false,
                        "selections": [
                          v2,
                          v12
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DocumentsRequiringAcceptancePageQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToAccept",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentsToAcceptPageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryType",
            "plural": true,
            "selections": [
              v2,
              v3,
              v13
            ]
          },
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentsToAccept",
            "storageKey": null,
            "args": v5,
            "concreteType": "DocumentImportAcceptCountableConnection",
            "plural": false,
            "selections": [
              v6,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentImportAcceptCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentImportAcceptType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "bloc",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BlocType",
                            "plural": false,
                            "selections": v14
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": v14
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "author",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ApprovalStepUserType",
                            "plural": false,
                            "selections": [
                              v8,
                              v9,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProfileType",
                                "plural": false,
                                "selections": [
                                  v10,
                                  v13
                                ]
                              },
                              v13
                            ]
                          },
                          v11,
                          v13
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentImport",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentImportType",
                        "plural": false,
                        "selections": [
                          v2,
                          v12,
                          v13
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
node.text = "query DocumentsRequiringAcceptancePageQuery(\n  $first: Int\n  $after: String\n  $sort: String\n  $categories: [Int]\n) {\n  documentsToAccept(sort: $sort, categories: $categories) {\n    categories {\n      pk\n      name\n      id\n    }\n    error {\n      statusCode\n      message\n    }\n    documentsToAccept(first: $first, after: $after) {\n      totalCount\n      edges {\n        node {\n          document {\n            pk\n            name\n            bloc {\n              name\n              id\n            }\n            category {\n              name\n              id\n            }\n            author {\n              firstName\n              lastName\n              profile {\n                title\n                id\n              }\n              id\n            }\n            expirationDate\n            id\n          }\n          documentImport {\n            pk\n            importFile {\n              name\n              url\n              zipName\n              zipUrl\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n";
(node/*: any*/).hash = '06a39f879b76923d40570ad40e146a50';
module.exports = node;
